module.exports = __webpack_public_path__ + "static/media/warningIcon.a5f7e0cd.svg";